<template>
<CRow>

  <CCol class="cards-parking"  xl="5" lg="7" md="6" sm="8" 
    :style="{'max-height': sizeHeight}"
  >
    <CRow class="parking-list">
      <ParkingCard
        v-for="(item, index) in items"
        :key="index"
        :item="item"
        cardClasses="col-lg-12 col-md-12 col-sm-12 col-12 h-100 mb-3"
        @sendCoords="getCoords"
      />
    </CRow>
  </CCol>

  <CCol xl="7" lg="5" md="6" sm="4">
    <div v-if="markers.length > 0">
      <map-parking-position
        :key="childKey"
        :height="sizeHeight"
        :coordsParent="{lat: Number(coord.lat), lng: Number(coord.lng)}"
        :markersParent="markers"
      ></map-parking-position>
    </div>
  </CCol>

  </CRow>
</template>

<script>

import ParkingCard from "../components/ParkingCard";
import MapParkingPosition from "@/app/shared/components/map/MapParkingPosition";

export default {
  name: "ListaParkings",
  components: {
    ParkingCard,
    MapParkingPosition
  },
  props: {
    elemento: { type: String, default: "Listado de Párkings" },
    title: String,
    loading: Boolean,
    parkings: { type: Array, default: [], required: true },
    sizeHeight: { type: String, default: '600px'}
  },
  computed:{
    items: {
      get: function () {
        return this.parkings;
      },
      set: function (newValue) {
        this.$emit("update:parkings", newValue);
      },
    },

  },
  data() {
    return {
      // items: [],
      coord: { lat: 0, lng: 0},
      markers: [],
      windowHeight: null,
      windowWidht: null,
      childKey: 0,
      zoom: 12
    };
  },
  mounted() {
    // this.getData();
    this.windowHeight = window.innerHeight;
    this.windowWidht = window.innerWidth;

  },
  watch: {
    items(items) {
      if (items) {
        this.getData();
      }
    },
  },

  methods: {

    getData() {
      try {

        if ( this.items ) {
          this.markers = [];
          this.items.map((p) => {

            p;
            p.label = p.name;
            p.title = p.name;
            p.marker = this.formatMarker(p);
          });

          this.items.forEach(item => {
            this.markers.push(item.marker);
          });

          this.setCenter({latitude: this.items[0]?.latitude , longitude: this.items[0]?.longitude });
          // this.coord = { lat: Number(this.items[0].latitude), lng: Number(this.items[0].longitude)};
        }


      } catch (e) {
        console.log(e);

        navigator.geolocation.getCurrentPosition(position => {
          this.setCenter({latitude: position.latitude , longitude: position.longitude });
        });
      }
    },
    setCenter({latitude, longitude}) {
      this.coord = {
        lat: Number(latitude),
        lng: Number(longitude),
      }
      // this.zoom = 12;
    },
    getCoords(coords) {

      this.coord = coords;
    },
    formatMarker({ latitude, longitude, label = 'dirección', title = 'Origen', infoText = null }) {

      const mapMarker =  require('@/assets/img/marker.svg');

      const marker =
      {
        position:
        {
          lat: Number(latitude),
          lng: Number(longitude)
        },
        icon: {
          url: mapMarker,
          // url: this.getIcon({text: null, fillColor: '3dada8', textColor: '303339', outlineColor: '303339'}) ,
          size: {width: 60, height: 30, f: 'px', b: 'px',},
          scaledSize: {width: 60, height: 30, f: 'px', b: 'px',},
          // scaledSize: {width: 28, height: 28},
          labelOrigin: {x: 27, y: -10}
        },
        title: label,
        label: {
          text: label,
          color: "black",
          fontWeight: "bold",
          fontSize: "12px",
          strokeColor: '#000000',
          className: 'shadowOutline'
          // className, color, fontFamily, fontSize, fontWeight, text
        },
        infoText: infoText ? infoText : title,
        // 1 = Bounce, 2 = Drop
        animation: 2
      }

      return marker
    },
    getIcon({text, fillColor, textColor, outlineColor}) {
      if (!text) text = '•'; //generic map dot
      // var iconUrl = "http://chart.googleapis.com/chart?cht=d&chdp=mapsapi&chl=pin%27i\\%27[" + text + "%27-2%27f\\hv%27a\\]h\\]o\\" + fillColor + "%27fC\\" + textColor + "%27tC\\" + outlineColor + "%27eC\\Lauto%27f\\&ext=.png";
      var iconUrl = require('@/assets/img/marker.svg');
      return iconUrl;

      // 'http://maps.google.com/mapfiles/ms/icons/green-dot.png';
      // `http://www.googlemapsmarkers.com/v1/3dada8/`;  // primary + borde negro
      // uigo-marker.png
      // require('@/assets/img/rider-marker-red.svg') }
      // rider-marker.svg
      // moto-marker.png
      // paqueterecogido_720x1280
    },
    forceRerender() {
      this.childKey += 1;
    },
  },
};
</script>

<style>
.cards-parking {
  /* max-height: 600px; */
  overflow: scroll;
    overflow-x: hidden; /* Hide horizontal scrollbar */

}

</style>
